import { render, staticRenderFns } from "./masterdata-summary.vue?vue&type=template&id=ee20fee2&scoped=true&lang=pug"
import script from "./masterdata-summary.vue?vue&type=script&lang=ts"
export * from "./masterdata-summary.vue?vue&type=script&lang=ts"
import style0 from "./masterdata-summary.vue?vue&type=style&index=0&id=ee20fee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee20fee2",
  null
  
)

export default component.exports